import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import useApiUrls from "../../useApiUrls";

const SendMQTTSetting = () => {
  const { merchant, pos } = useParams();
  const location = useLocation();
  const stateStoreId = location.state?.storeid || "all";

  const [merchantname, setMerchantname] = useState(merchant || "All");
  const [storeid, setStoreid] = useState(stateStoreId);
  const [posid, setPosid] = useState(pos || "0");
  const [Jsonid, setJsonid] = useState("");
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [merchantList, setMerchantList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [posList, setPosList] = useState([]);
  const [JsonList, setJsonList] = useState([]);

  const navigate = useNavigate();
  const { getUrlByOperation } = useApiUrls();


  const fetchMerchants = async () => {

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    try {
      const posGetDistinctMerchantId = getUrlByOperation("posGetDistinctMerchantId");
      console.log("URL for posGetDistinctMerchantId:", posGetDistinctMerchantId);

      if (!posGetDistinctMerchantId) {
        console.error("URL for posGetDistinctMerchantId operation not found.");
        return;
      }

      const response = await axios.get(posGetDistinctMerchantId, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          accept: "text/plain",
        },
      });

      if (response.data && Array.isArray(response.data.data)) {
        setMerchantList(response.data.data.map((item) => item.merchantid));
      } else {
        setMerchantList([]);
        console.warn("Merchant list is empty or in unexpected format.");
      }
    } catch (error) {
      console.error("Error fetching merchant list:", error);
      if (error.response?.data.message === "relogin token expire") {
        navigate("/login");
      }
    }
  };

  const fetchStoresByMerchant = async (merchantId) => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    try {
      const response = await axios.get(
        `https://api.dqr-display-tms.eventum.co.in/api/POSOperation/GetDistinct/specificstoreidbymerchantid_active/${merchantId}`,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            accept: "text/plain",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setStoreList(response.data.data.map((item) => item.storeid || item.value || item.id));
      } else {
        setStoreList([]);
      }
    } catch (error) {
      console.error("Error fetching Store list:", error);
      setStoreList([]);
    }
  };

  const fetchPosByStore = async (storeId) => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    try {
      const response = await axios.get(
        `https://api.dqr-display-tms.eventum.co.in/api/POSOperation/GetDistinct/specificposbystoreid_active/${storeId}`,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            accept: "text/plain",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setPosList(response.data.data.map((item) => ({
          id: item.id,
          value: item.value,
        })));
      } else {
        setPosList([]);
      }
    } catch (error) {
      console.error("Error fetching POS list:", error);
      setPosList([]);
    }
  };



  // Fetch Json IDs from the search API
  const fetchJsonIds = async () => {

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const requestBody = {
      filesize: 0,
      id: 0,
      applycreateddate: false,
      fromcreateddate: 0,
      endcreateddate: 0,
      active: "",
      orgfilename: "",
      systemfilename: "",
      downloadpath: "",
      name: "",
      ispageload: false,
      pagesize: 1000,
      currentpageno: 0,
      withoutpagination: false,
      pagedirection: "first",
    };

    try {
      // const JsonSearch = getUrlByOperation("JsonSearch");

      const response = await axios.post(
        'https://api.dqr-display-tms.eventum.co.in/api/JsonSettingOperation/Search',
        requestBody,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setJsonList(response.data.data); // Set the Json list with data from the API
      } else {
        setJsonList([]);
      }
    } catch (error) {
      console.error("Error fetching Json IDs:", error);
    }
  };


  // Function to handle the API call
  const handleSendJson = async () => {
    if (!Jsonid) {
      setErrorMessage("Please select an Json.");
      return;
    }

    setLoading(true);
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const requestBody = {
      merchantname,
      storeid,
      posid: posid || "0",
      jsonsettingid: parseInt(Jsonid),
    };

    try {

      const response = await axios.post('https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/JsonSetting', requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json",
        },
      });

      if (response.data && response.data.sendresult) {
        setResponseData(response.data.sendresult);
        setErrorMessage("");
      } else {
        setResponseData(null);
        setErrorMessage(response.data.errormsg || "No matching records found");
      }
    } catch (error) {
      console.error("Error sending Json:", error);
      setErrorMessage("Failed to send Json.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJsonIds();
  }, [getUrlByOperation]);

  // Fetch initial data if params are present
  useEffect(() => {
    if (merchantname && merchantname !== "Select" && merchantname !== "All") {
      fetchStoresByMerchant(merchantname);
    }
  }, [merchantname]);

  useEffect(() => {
    if (storeid && storeid !== "all") {
      fetchPosByStore(storeid);
    }
  }, [storeid]);

  return (
    <>
      <Menu />
      <div className="content-wrapper" style={{ padding: "20px" }}>
        <div
          style={{
            backgroundColor: "var(--surface)",
            padding: "2rem",
            borderRadius: "8px",
            width: "400px",
            margin: "auto",
          }}
        >
          <h4 style={{ marginBottom: "20px" }}>Send Json</h4>
          <div className="form-group">
            <label>Merchant Name</label>
            {merchant ? (
              <select
                className="form-control"
                value={merchantname}
                disabled
              >
                <option value={merchant}>{merchant}</option>
              </select>
            ) : (
              <select
                className="form-control"
                value={merchantname}
                onChange={(e) => {
                  const selectedMerchant = e.target.value;
                  setMerchantname(selectedMerchant);
                  setStoreid("all");
                  setPosid("0");
                  if (selectedMerchant && selectedMerchant !== "All") {
                    fetchStoresByMerchant(selectedMerchant);
                  } else {
                    setStoreList([]);
                    setPosList([]);
                  }
                }}
                onFocus={fetchMerchants} // Fetch merchants when dropdown is clicked
              >
                <option value="Select">Select</option>
                <option value="All">All</option> {/* Default 'All' option */}
                {merchantList.map((merchant, index) => (
                  <option key={index} value={merchant}>
                    {merchant}
                  </option>
                ))}
              </select>
            )}
          </div>

          <div className="form-group">
            <label>Store ID</label>
            <select
              className="form-control"
              value={storeid}
              onChange={(e) => {
                const selectedStore = e.target.value;
                setStoreid(selectedStore);
                setPosid("0");
                if (selectedStore && selectedStore !== "all") {
                  fetchPosByStore(selectedStore);
                } else {
                  setPosList([]);
                }
              }}
              disabled={!merchantname}
              style={{ backgroundColor: "var(--surface)", color: "var(--text)" }}
            >
              <option value="all">All</option>
              {storeList.map((store, index) => (
                <option key={index} value={store}>
                  {store}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>POS ID</label>
            {pos ? (
              <select className="form-control" value={String(posid)} disabled>
                {posList.length > 0 ? (
                  posList.map((p, index) => (
                    <option key={index} value={String(p.id)}>
                      {p.value}
                    </option>
                  ))
                ) : (
                  <option value={String(pos)}>{pos}</option>
                )}
              </select>
            ) : (
              <select
                className="form-control"
                value={posid}
                onChange={(e) => setPosid(e.target.value)}
                disabled={!storeid}
                style={{ backgroundColor: "var(--surface)", color: "var(--text)" }}
              >
                <option value="0">All</option>
                {posList.map((pos, index) => (
                  <option key={index} value={pos.id}>
                    {pos.value}
                  </option>
                ))}
              </select>
            )}
          </div>

          <div className="form-group">
            <label>Json ID</label>
            <select
              className="form-control"
              value={Jsonid}
              onChange={(e) => {
                setJsonid(e.target.value);
                setErrorMessage(""); // Clear error when user selects an Json
              }}
            >
              <option value="">Select Json</option>
              {JsonList.map((Json, index) => (
                <option key={index} value={Json.id}>
                  {Json.settingname}
                </option>
              ))}
            </select>
            {errorMessage && !Jsonid && (
              <div style={{ color: "red", marginTop: "0.5rem" }}>{errorMessage}</div>
            )}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "1rem",
            }}
          >
            <button
              className="btn btn-primary"
              onClick={handleSendJson}
              disabled={loading || !Jsonid}
            >
              {loading ? "Sending..." : "Send Json"}
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row" style={{ marginTop: "20px" }}>
              <div className="col-12">
                <div className="card">
                  <div className="card-body table-responsive p-0">
                    <table className="table table-hover text-nowrap">
                      <thead>
                        <tr>
                          <th>Merchant Name</th>
                          <th>Store ID</th>
                          <th>POS Name</th>
                          <th>Response Status</th>
                          <th>Error Message</th>
                        </tr>
                      </thead>
                      <tbody>
                        {responseData ? (
                          responseData.length > 0 ? (
                            responseData.map((result, index) => (
                              <tr key={index}>
                                <td>{result.merchantname}</td>
                                <td>{result.storeid || "-"}</td>
                                <td>{result.posname}</td>
                                <td>{result.responsestatus}</td>
                                <td>{result.errormsg}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" style={{ textAlign: "center" }}>
                                No data available yet
                              </td>
                            </tr>
                          )
                        ) : (
                          <tr>
                            <td colSpan="5" style={{ textAlign: "center" }}>
                              {errorMessage || "No matching records found"}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SendMQTTSetting;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}


